enum PoolingCommand {
  'CALL_WAITER',
  'CLEAN_TABLE',
  'CHECK_BILL',
}

export default PoolingCommand;
